import { LogLevel } from '@azure/msal-browser';

const environment = process.env.REACT_APP_IMS_ENV ?? 'development';
const clientId = process.env.REACT_APP_CLIENT_APP_ID;
const apiEndpoint = process.env.REACT_APP_SERVER_INTERNAL_ENDPOINT;
const adobeSignEndpoint = process.env.REACT_APP_SERVER_ADOBE_ENDPOINT;

const msalConfig = {
	auth: {
		clientId: clientId,
		authority: `https://login.microsoftonline.com/upmchs.onmicrosoft.com`,
		redirectUri: window.location.origin + '/index.html',
		postLogoutRedirectUri: window.location.origin + '/Login.aspx',
	},
	cache: {
		cacheLocation: 'localStorage',
	},
	system: {
		allowRedirectInIframe: true,
		loggerOptions: {
			loggerCallback: (level, message) => {
				if (environment !== 'development' && environment !== 'test') {
					return;
				}
				switch (level) {
					case LogLevel.Error:
						console.error(message);
						return;
					case LogLevel.Info:
						return;
					case LogLevel.Verbose:
						console.debug(message);
						return;
					case LogLevel.Warning:
						console.warn(message);
						return;
					default:
						console.log(message);
						return;
				}
			},
		},
		piiLoggingEnabled: environment === 'development',
	},
	requests: {
		api: {
			scopes: [`${apiEndpoint}/user_impersonation`],
		},
		adobeSignApi: {
			scopes: [`${adobeSignEndpoint}/ReadWrite`],
		},
		graph: {
			scopes: [
				'https://graph.microsoft.com/User.Read',
				'https://graph.microsoft.com/profile',
				'User.Read',
			],
		},
	},
};

export default msalConfig; 